//
// Module for the Milestone Configuration edit
//
rs.module("fund/configuration/milestones/edit",

    [
        "ui/controls/input-tokens",
        "common/select-helper",
    ],

    function (inputTokens, selectHelper) {

        var _grid;
        var _occurrenceCard;

        // Initialize the module
        function initialize(jsSelectors, ajaxUrls, gridVariable) {
            var milestoneConfigForm = $.js(jsSelectors.milestoneConfigForm);

            var milestoneTypeSelect = milestoneConfigForm.js(jsSelectors.milestoneTypeSelect);
            var forecastPeriod = milestoneConfigForm.js(jsSelectors.forecastPeriod);
            var tokens = milestoneConfigForm.js(jsSelectors.tokens);

            var emailSelect = milestoneConfigForm.js(jsSelectors.emailSelect);
            var emailSelectHelper = selectHelper.getHelper(emailSelect);
            var correspondenceSelect = milestoneConfigForm.js(jsSelectors.correspondenceSelect);
            var correspondenceSelectHelper = selectHelper.getHelper(correspondenceSelect);

            var workflowSelect = milestoneConfigForm.js(jsSelectors.workflowSelect);
            var alwaysStartWorkflowCheckBox = milestoneConfigForm.js(jsSelectors.alwaysStartWorkflowCheckBox);
            var forecastCommunicationCheckbox = milestoneConfigForm.js(jsSelectors.forecastCommunicationCheckbox);

            _occurrenceCard = milestoneConfigForm.js(jsSelectors.occurrenceCard);

            setGrid(gridVariable);

            // On Milestone Type select change, reload the tokens, show appropriate occurrence grid
            milestoneTypeSelect.change(function () {
                // Update the tokens for the chosen milestone
                $.get(ajaxUrls.getTokens, { milestoneType: this.value }).done(function (result) {
                    tokens.html(result);
                    inputTokens.reinitialize();
                });

                // Get any grid content
                $.get(ajaxUrls.getGrid, { milestoneType: this.value }).done(function (results) {
                    milestoneConfigForm.js(jsSelectors.occurrencesContent).html(results);
                });
            });

            // When the amount of forecast period days are changed, we might have to disable the Send Forecast Communications checkbox
            forecastPeriod.on('input', setForecastCommunicationEnabled);

            // On Send Email select change, toggle the Generate Correspondence select
            emailSelect.change(function () {
                correspondenceSelectHelper.setDisabled(this.value != "");
                setForecastCommunicationEnabled();
            });

            // On Generate Correspondence select change, toggle the Send Email select
            correspondenceSelect.change(function () {
                emailSelectHelper.setDisabled(this.value != "");
                setForecastCommunicationEnabled();
            });

            // On Start Workflow select change, toggle the Always Start checkbox
            workflowSelect.change(function () {
                var enable = this.value != "";

                if (!enable) {
                    alwaysStartWorkflowCheckBox.prop('checked', false);
                }
                    
                alwaysStartWorkflowCheckBox.prop('disabled', !enable);
            });

            // Hook up a grid's Add link click
            milestoneConfigForm.js(jsSelectors.addOccurrenceLink).click(function () {
                // get current grid and add row
                if (_grid) {
                    _grid.addRow();
                }
            });

            // Only enable forecast communication checkbox if there is a forecast period, and communications to send. Otherwise, disable and uncheck it
            function setForecastCommunicationEnabled() {
                var hasCommunicationAndForecastPeriod = (emailSelect.val() != "" || correspondenceSelect.val() != "") && forecastPeriod.val() > 0;
                forecastCommunicationCheckbox.setChecked(hasCommunicationAndForecastPeriod ? forecastCommunicationCheckbox.is(":checked") : false);
                forecastCommunicationCheckbox.setDisabled(!hasCommunicationAndForecastPeriod);
            }
        }

        // Set the current grid instance
        function setGrid(grid) {
            _grid = grid;

            if (_occurrenceCard) {
                if (grid) {
                    // show card
                    _occurrenceCard.show();
                }
                else {
                    // hide all
                    _occurrenceCard.hide();
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            setGrid: setGrid
        };

        return exports;
    }
);